"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServTwit = void 0;
const base_1 = require("./base");
class AnServTwit extends base_1.AnServBase {
    static isLoaded() {
        return (window.twq !== undefined);
    }
    static sendInit(pixelId, userId, email, coupon) {
        twq("init", pixelId);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId,
        });
        return true;
    }
    static sendPage(pixelId, tags = null) {
        twq("track", "PageView");
        this.logEvent({
            cmd: "track",
            eventName: "PageView",
        });
        return true;
    }
}
exports.AnServTwit = AnServTwit;
AnServTwit.serviceName = "Twitter";
